/**
 * key                  系统语言标识 
 *      extLang         必填
 *      macroLang       必填, 用于多语言的简写标识，匹配菜单配置数据data.my，API请求参数header中的Accept-Language
 *
 * extLang,macroLang    拼接为Accept-Language  如 ha-NG,ng
 * */ 
export const langConfig = {
    'zh-CN' : {
        extLang: 'zh-CN',
        macroLang: 'zh'
    },
    'en-US' : {
        extLang: 'en-US',
        macroLang: 'en'
    },
    'my': {
        extLang: 'my-MM',
        macroLang: 'my'
    },
    'pt' : {
        extLang: 'pt-AO',
        macroLang: 'pt'
    },
    'fr' : {
        extLang: 'fr-FR',
        macroLang: 'fr'
    }
}

export const SYS_LOCAL_LANG_KEY = 'sysLang'

